import { FunctionComponent, useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { createApi, editApi } from "../../../Services/organizations";
import { showSnackbarAction } from "../../../Redux/actions";
import { themeColors } from "../../theme";
import { CountryData } from "react-phone-input-2";
import "../../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import Modal, { Styles } from "react-modal";
import StyledCancelButton from "../../Buttons/StyledCancelButton";
import StyledSubmitButton from "../../Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import DropDownText from "../../DropDownText/DropDownText";
import PhoneNumberWrapper from "../../TextInput/PhoneNumberWrapper";


/* ------------------------------------------------------------------
   TYPES
-------------------------------------------------------------------*/
type props = {
  open: boolean;
  close: () => void;
  organizationId: any;
  organizationUsers: any;
  edit?: boolean;
  editData?: any;
  editClose?: () => void;
  leadSourceList?: any;
  apiData?: any;
  theme?: any;
  OrgData?: any;
  Master?: boolean;
  setSeletedOrg?: any;
  seletedOrg?: any;
};

/* ------------------------------------------------------------------
   COMPONENT
-------------------------------------------------------------------*/
const ApiModal: FunctionComponent<props> = ({
  organizationId,
  open,
  close,
  edit,
  editData,
  editClose,
  leadSourceList,
  apiData,
  theme,
  OrgData,
  Master,
  setSeletedOrg,
  seletedOrg,
}) => {

  /* ---------------------------------------------
   THEME + RESPONSIVE
----------------------------------------------*/
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  /* ---------------------------------------------
   STATE
----------------------------------------------*/
  const [load, setLoad] = useState(false);
  const [source, setSource] = useState<any>({ label: "Select", value: "Select" });
  const [selectCountryCode, setSelectCountryCode] = useState("+91");
  const [countryCode, setCountryCode] = useState();
  const dispatcher = useDispatch();

  /* ---------------------------------------------
    LEAD SOURCE OPTION MAPPER
 ----------------------------------------------*/
  const choice = () => {
    return leadSourceList?.map(
      (list: { leadSource: any; leadSource_id: any }) => ({
        value: list.leadSource,
        label: list.leadSource,
        leadSource_id: list.leadSource_id,
      })
    );
  };


  /* ---------------------------------------------
     ORGANIZATION DROPDOWN MAPPER (MASTER MODE)
  ----------------------------------------------*/
  const choiceOrg = () => {
    if (!Array.isArray(OrgData) || OrgData.length === 0) return [];
    return OrgData.map(
      (list: { organization_name?: string; org_id?: string }) => ({
        value: list?.org_id ?? "",
        label: list?.organization_name ?? "",
      })
    );
  };

  /* ---------------------------------------------
     AUTO-FILL EDIT MODE VALUES
  ----------------------------------------------*/
  useEffect(() => {
    if (edit && editData) {
      // ✅ Autofill Source
      const sourceObj = choice()?.find(
        (item: any) => item.value === editData.source
      );

      if (sourceObj) {
        setSource(sourceObj);
      } else {
        setSource({
          value: editData.source,
          label: editData.source,
          leadSource_id: editData.leadSource_id ?? null,
        });
      }

      // ✅ Autofill Org in MASTER mode
      if (Master) {
        const selectedOrg = choiceOrg()?.find(
          (item: any) => item.value === editData.organization_id
        );
        if (selectedOrg) {
          setSeletedOrg(selectedOrg);
        }
      }

      setSelectCountryCode(editData.country_code ?? "+91");
      setCountryCode(editData.country_code ?? "+91");
    }
  }, [edit, editData, leadSourceList, OrgData]);


  /* ------------------------------------------------------------
      Save (MASTER MODE)
  ------------------------------------------------------------ */
  const onSaveMaster = () => {
    if (seletedOrg?.value === "Select") {
      dispatcher(showSnackbarAction("Please Enter Organization!!", "error"));
      return;
    } else if (source?.value === "Select") {
      dispatcher(showSnackbarAction("Please Enter Source!!", "error"));
      return;
    }

    const apiFilterData = apiData.some(
      (item: any) =>
        item.source?.toLowerCase() === source.value.toLowerCase() &&
        item.organization_id === seletedOrg.value
    );

    if (apiFilterData) {
      dispatcher(showSnackbarAction("Source already exists!!", "error"));
      return;
    }

    setLoad(true);
    createApi(
      seletedOrg.value,
      source?.value,
      source?.leadSource_id ?? null,
      selectCountryCode,
      dispatcher,
      (val) => setLoad(val),
      close
    );
  };

  /* ------------------------------------------------------------
      Save (ORG normal user)
  ------------------------------------------------------------ */
  const onSave = () => {
    if (source?.value === "Select") {
      dispatcher(showSnackbarAction("Please Enter Source!!", "error"));
      return;
    }

    const apiFilterData = apiData.some(
      (item: any) =>
        item.source?.toLowerCase() === source.value.toLowerCase() &&
        item.organization_id === organizationId
    );

    if (apiFilterData) {
      dispatcher(showSnackbarAction("Source already exists!!", "error"));
      return;
    }

    setLoad(true);
    createApi(
      organizationId,
      source?.value,
      source?.leadSource_id ?? null,
      selectCountryCode,
      dispatcher,
      (val) => setLoad(val),
      close
    );
  };

  /* ------------------------------------------------------------
      Edit (MASTER)
  ------------------------------------------------------------ */
  const masterOnEdit = () => {
    if (seletedOrg?.value === "Select") {
      dispatcher(showSnackbarAction("Please Enter Organization!!", "error"));
      return;
    } else if (source?.value === "") {
      dispatcher(showSnackbarAction("Please Enter Source!!", "error"));
      return;
    }
    if (editClose) {

      const apiFilterData = apiData.some(
        (item: any) =>
          item.api_key !== editData.api_key && // current record skip
          item.source?.toLowerCase() === source.value.toLowerCase() &&
          item.organization_id === seletedOrg.value &&
          item.country_code === selectCountryCode // ✅ IMPORTANT
      );

      if (apiFilterData) {
        dispatcher(showSnackbarAction("Source already exists!!", "error"));
        return;
      }
      setLoad(true);
      editApi(
        source?.value,
        source?.leadSource_id ?? null,
        selectCountryCode,
        editData.api_key,
        dispatcher,
        (data) => setLoad(data),
        close,
        editClose
      );
    }
  };

  /* ------------------------------------------------------------
      Edit Normal
  ------------------------------------------------------------ */
  const onEdit = () => {

    if (source?.value === "") {
      dispatcher(showSnackbarAction("Please Enter Source!!", "error"));
      return;
    }

    if (editClose) {
      const apiFilterData = apiData.some(
        (item: any) =>
          item.api_key !== editData.api_key && // current record skip
          item.source?.toLowerCase() === source.value.toLowerCase() &&
          item.organization_id === organizationId &&
          item.country_code === selectCountryCode // ✅ IMPORTANT
      );

      if (apiFilterData) {
        dispatcher(showSnackbarAction("Source already exists!!", "error"));
        return;
      }
      setLoad(true);
      editApi(
        source?.value,
        source?.leadSource_id ?? null,
        selectCountryCode,
        editData.api_key,
        dispatcher,
        (data) => setLoad(data),
        close,
        editClose
      );
    }
  };

  /* ------------------------------------------------------------
      Modal Styling
  ------------------------------------------------------------ */
  const modalStyle: Styles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1300,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      background: theme
        ? themeColors.cardBackgroundColor
        : themeColors.cardBackgroundColorDark,
      color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
      borderRadius: 16,
      padding: isMobile ? "24px 12px" : "40px 32px",
      maxWidth: 380,
      minWidth: 320,
      border: "none",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      inset: "auto",
      margin: "auto",
    },
  };

  const handlePhoneChange = (value: string, country: CountryData) => {
    setSelectCountryCode(`+${country?.dialCode}`);
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      style={modalStyle}
      ariaHideApp={false}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 340,
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <form style={{ width: "100%" }}>
          <Box sx={{ mb: 2 }}>
            <h3
              style={{
                color: theme ? "#272944" : "#fff",
                fontFamily: "var(--font-family-main)",
                fontSize: "var(--font-size-large)",
                marginBottom: 24,
                textAlign: "center",
                fontWeight: 700,
                letterSpacing: 0.5,
              }}
            >
              {edit === true ? <>Edit API</> : <>Create API</>}
            </h3>
          </Box>
          <Grid container spacing={2} sx={{ width: "100%" }}>
            {/* ORG dropdown in MASTER */}
            {Master && (
              <Grid item xs={12}>
                <DropDownText
                  title="Organization (Select one)"
                  options={choiceOrg()}
                  value={
                    seletedOrg?.value === "Select" ? "" : seletedOrg?.value
                  }
                  onChange={(e: any) => {
                    const selected = choiceOrg()?.find(
                      (item: any) => item.value === e.target.value
                    );
                    setSeletedOrg(
                      selected || {
                        value: e.target.value,
                        label: e.target.value,
                      }
                    );
                  }}
                  required
                  labelKey="label"
                  valueKey="value"
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <DropDownText
                title="Source"
                options={choice()}
                value={source?.value === "Select" ? "" : source?.value}
                onChange={(e: any) => {
                  const selected = choice()?.find(
                    (item: any) => item.value === e.target.value
                  );
                  setSource(
                    selected || {
                      value: e.target.value,
                      label: e.target.value,
                    }
                  );
                }}
                required
                labelKey="label"
                valueKey="value"
                disabled={seletedOrg?.value === "Select" && Master}
              />
            </Grid>

            <Grid item xs={12}>
              <PhoneNumberWrapper
                title="Country Code"
                value={selectCountryCode || ""}
                handlePhoneChange={handlePhoneChange}
                disabled={true}
                required
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 4,
                width: "100%",
              }}
            >
              <Box style={{ marginRight: 8 }}>
                <StyledCancelButton onClick={close} isMobile={isMobile}>
                  Cancel
                </StyledCancelButton>
              </Box>

              <Box>
                {edit === true ? (
                  <StyledSubmitButton
                    onClick={Master ? masterOnEdit : onEdit}
                    themeMode={themeMUI.palette.mode}
                    isMobile={isMobile}
                  >
                    {load ? (
                      <span style={{ display: "flex", justifyContent: "center" }}>
                        <Circles color="#fff" height={20} width={20} />Editing..
                      </span>
                    ) : (
                      <>Edit</>
                    )}
                  </StyledSubmitButton>
                ) : (
                  <StyledSubmitButton
                    onClick={Master ? onSaveMaster : onSave}
                    themeMode={themeMUI.palette.mode}
                    isMobile={isMobile}
                  >
                    {load ? (
                      <span style={{ display: "flex", justifyContent: "center" }}>
                        <Circles color="#fff" height={20} width={20} />Submit...
                      </span>
                    ) : (
                      <>Submit</>
                    )}
                  </StyledSubmitButton>
                )}
              </Box>
            </Box>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(ApiModal);
